import { IconProps } from './types'

export const ChevronRightIcon = ({ className, width = 10, height = 10, viewBox = '0 0 15 15' }: IconProps) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none" aria-hidden="true">
    <path d="m6 3 5 5-5 5" stroke="currentColor" strokeLinecap="square" />
  </svg>
)
